import { Pipe, PipeTransform } from '@angular/core';
import { leadSources } from '@shared/constants/lead-sources';

@Pipe({
  name: 'leadSource',
  standalone: false,
})
export class LeadSourcePipe implements PipeTransform {
  transform(value: string): string {
    return leadSources.find((leadSource) => leadSource.reference === value)?.title || value;
  }
}
